import React from 'react';
import { formatCurrency, formatShortDate, STATUS_DOT_COLORS } from './ordersHelpers';

const ChannelTag = ({ channel }) => (
  <span
    className={`inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-medium ${
      channel === 'Shopify' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
    }`}
  >
    {channel}
  </span>
);

const StatusTag = ({ status, channel }) => {
  if (!status) return null;
  const [dotColor, textColor] = STATUS_DOT_COLORS(status, channel).split(' ');
  return (
    <span className={`inline-flex items-center gap-1.5 text-[12.5px] font-medium ${textColor}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`} />
      {status}
    </span>
  );
};

// Mobile-only card layout for the orders list.
const OrdersCardList = ({ orders, selectedIds, onToggleSelect, onOpen }) => {
  if (orders.length === 0) {
    return (
      <div className="px-4 py-16 text-center text-sm text-gray-400">
        No orders match the current filters.
      </div>
    );
  }
  return (
    <ul className="divide-y divide-gray-100">
      {orders.map((order) => {
        const selected = selectedIds.includes(order.id);
        const items = order.OrderLineItems || [];
        const first = items[0];
        const extra = items.length - 1;
        return (
          <li
            key={order.id}
            onClick={() => onOpen(order.id)}
            className={`flex cursor-pointer items-start gap-3 px-4 py-3 transition-colors active:bg-gray-50 ${
              selected ? 'bg-gray-100' : ''
            }`}
          >
            <span onClick={(e) => e.stopPropagation()} className="pt-0.5">
              <input
                type="checkbox"
                checked={selected}
                onChange={() => onToggleSelect(order.id)}
                className="h-4 w-4 accent-gray-900 rounded"
                aria-label={`Select order ${order.external_order_id}`}
              />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-[13px] font-semibold tabular-nums text-gray-900">
                  #{String(order.external_order_id).slice(-8)}
                </span>
                <span className="text-[13px] font-semibold tabular-nums text-gray-900">
                  {formatCurrency(order.display_total_paid ?? order.total_paid) ?? '\u2014'}
                </span>
              </div>
              <div className="mt-0.5 flex items-center gap-2">
                <ChannelTag channel={order.channel} />
                <StatusTag status={order.order_status} channel={order.channel} />
              </div>
              <div className="mt-1 flex items-center justify-between gap-2">
                <span className="min-w-0 truncate text-xs text-gray-500">
                  {first ? first.Product?.name || first.sku || '\u2014' : '\u2014'}
                  {extra > 0 && <span className="text-gray-400"> +{extra}</span>}
                </span>
                <span className="flex-shrink-0 text-[11px] tabular-nums text-gray-500">
                  {formatShortDate(order.date_of_order)}
                </span>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default OrdersCardList;
